import React from 'react';
import { Modal, Input } from 'antd';
import FhSimpleTable from 'components/src/fhPaneTable/FhSimpleTable';

import BaseComponent from 'base/BaseComponent';
import { enhance } from 'base/BaseEnhance';

const { Search } = Input;

/**
 * 主页头部显示区域 -- 历史公告弹出框
 */
class NoticeHistoryModal extends BaseComponent {
  searchValues = {
    currentPage: 1,
    pageSize: 10,
    sortString: '',
    searchValueLike: null
  }

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      modalVisible: false,
      dataSource: [],
      total: 0
    };

    this.columns = [
      {
        title: '公告代码',
        key: 'noticeCode',
        dataIndex: 'noticeCode',
        fixed: true,
        width: 150
      },
      {
        title: '公告标题',
        key: 'noticeName',
        dataIndex: 'noticeName',
        fixed: true,
        width: 200
      },
      {
        title: '公告期间起',
        key: 'startDate',
        dataIndex: 'startDate',
        width: 150
      },
      {
        title: '公告期间止',
        key: 'endDate',
        dataIndex: 'endDate',
        width: 150
      }
    ];
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  showNoticeHistoryData = () => {
    this.setState({
      modalVisible: true,
      dataSource: []
    });
    this.getNoticeHistoryData();
  }

  getNoticeHistoryData = () => {
    this.setState({
      isLoading: true
    });
    this.sendPostRequest('/system/notice/getNoticeHistoryList', this.searchValues, (result) => {
      if (result != null) {
        this.setState({
          dataSource: result.infoList || [],
          total: result.totalRecord
        });
      }
    });
  }

  onFinally() {
    this.setState({
      isLoading: false
    });
  }

  // 分页、改页、排序
  onPageChange = (sortString, currentPage, pageSize) => {
    this.searchValues.currentPage = currentPage;
    this.searchValues.pageSize = pageSize;
    this.searchValues.sortString = sortString;
    this.getNoticeHistoryData();
  }

  handleInputSearch = (value) => {
    this.searchValues.searchValueLike = value;
    this.searchValues.currentPage = 1;
    this.getNoticeHistoryData();
  }

  handlePressEnter = (event) => {
    this.searchValues.searchValueLike = event.target.value;
    this.searchValues.currentPage = 1;
    this.getNoticeHistoryData();
  }

  onSelectedRows = (selectedRows) => {
    this.setState({
      selectedRows: selectedRows || []
    });
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  };

  render() {
    const { total, isLoading, modalVisible, dataSource } = this.state;

    return (
      <Modal
        title="查看历史公告"
        visible={modalVisible}
        onCancel={this.handleCancel}
        bodyStyle={{ maxHeight: 520 }}
        className="addModal paddingZeroModal"
        width={1000}
        footer={null}
      >
        <Search placeholder='请输入检索内容。' onSearch={this.handleInputSearch} onPressEnter={this.handlePressEnter} enterButton />
        <FhSimpleTable
          tableKey={'tb_stockupAddModal'}
          columns={this.columns}
          dataSource={dataSource}
          pagination={true}
          total={total}
          onPageChange={this.onPageChange}
          current={this.searchValues.currentPage}
          defaultPageSize={this.searchValues.pageSize}
          rowSelectionType='radio'
          expandable={{
            // eslint-disable-next-line react/display-name
            expandedRowRender: record => <p style={{ margin: 10 }}>{`公告内容：${record.noticeContent}`}</p>
          }}
          height={'400px'}
          isLoading={isLoading}
          onSelectedRows={this.onSelectedRows}
        />
      </Modal>
    );
  }
}

export default enhance(NoticeHistoryModal);
